import { sendDataLayer } from "./ecommerce/ecommerce";

export class InputValidator {
    customFieldValidationSuccess: boolean;
    fieldMandatory: string;
    EmailValidationError: string;
    phoneValidationError: string;
    nameTooShort: string;
    constructor(
        formId: string
    ) {
        if (!(window as any).initValidator)
        {
            (window as any).initValidator = true;
            const instance = this;

            $(".js-validation").each(function (this: HTMLElement) {
                const input = $(this)[0] as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
                const $input = $(input);

                if (!$input.hasClass("js-validation-loaded")) {
                    $input.on("input", () => {
                        instance.checkCustomFieldValid(input);
                    });

                    $input.on("blur", () => {
                        instance.checkCustomFieldValid(input);
                    });

                    if ($input.attr("type") === "email") {
                        $input.attr("pattern", "[^@\\s]+@[^@\\s]+\\.[^@\\s]{2,}");
                    }

                    $input.addClass("js-validation-loaded");
                }
            });

            const submitButton = $(`#${formId}`).find("button[type=submit]")[0] ?? $(`#${formId}`).find("input[type=submit]")[0];

            if (submitButton) $(submitButton).on("click", (event: any) => this.customFieldValidation(this, event));
        }
    }

    private checkCustomFieldValid = (input: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement, removeValidation?: boolean): void => {
        // Skip phonenumbers (see phonenumber.ts)
        if ($(input).attr("type") === "tel") return;

        if (typeof removeValidation === "undefined" || removeValidation === null)
            removeValidation = false;

        let valid: boolean = true;
        let failedInputValidation: string | null = null;
        const $input = $(input);
        const $parent = $input.parent();

        // When removing validation, skip validating and treat the field as valid.
        if (!removeValidation) {
            if (input.validity.typeMismatch || ($input.val() as string).match(/^ *$/)) {
                valid = false;
                failedInputValidation = this.fieldMandatory;
            }
            else {
                switch ($input.attr("type")) {
                    case "email":
                        {
                            if (input.validity.typeMismatch || input.validity.patternMismatch) {
                                valid = false;
                                failedInputValidation = this.EmailValidationError;
                            }

                            break;
                        }
                    case "tel":
                        {
                            if (input.validity.typeMismatch) {
                                valid = false;
                                failedInputValidation = this.phoneValidationError;
                            }

                            break;
                        }
                    case "radio":
                        {
                            // Check if any radio button with same name was checked.
                            if (typeof input.type !== "undefined" && input.type !== null && input.type === "radio" &&
                                typeof input.name !== "undefined" && input.name !== null && input.name.length > 0) {
                                if ($(`input[type="${input.type}"][name="${input.name}"]:checked`).length <= 0) {
                                    valid = false;
                                    failedInputValidation = this.fieldMandatory;
                                }
                            }
                        }
                }

                switch ($input.attr("name")) {
                    case "first":
                    case "first-delivery":
                        {
                            const firstValue = $input.val() as string;

                            if (firstValue && (firstValue.length === 1 || this.checkIfHasNumbers(firstValue))) 
                            {
                                valid = false;
                                failedInputValidation = this.nameTooShort;
                            }
                        }
                }

                // Check if field meets the minimum length requirement
                if (typeof $input.data("errorminlength") !== "undefined") {
                    let minimumLength = $input.data("errorminlength");

                    if (typeof minimumLength !== "undefined" && ($input.val() as string).trim().length < minimumLength) {
                        valid = false;
                        failedInputValidation = this.fieldMandatory;
                    }
                }
            }
        }

        // Also run when removing validation, to do the removing itself.
        if (valid || removeValidation) {
            input.setCustomValidity("");
            $(input).removeClass("js-validation-failed field-error");
            $(input).addClass("js-validation-success");
            if ($parent.hasClass("input-wrapper")) {
                $(input).parent().removeClass("input-wrapper--failed");
                $(input).parent().addClass("input-wrapper--success");
            }

            // For radio buttons and checkboxes, remove invalid class from all with same name.
            if ((input.type === "radio" || input.type === "checkbox") &&
                input.name.length > 0) {
                // Inputs of same type and name that have validation failed class.
                const selector = `input[type="${input.type}"][name="${input.name}"].js-validation-failed`;

                $(selector).removeClass("js-validation-failed field_error");
            }

            if ($input.hasClass("js-validation-showmessage") && $input.siblings(".validationerrormessage").length > 0) {
                $input.siblings(".validationerrormessage").each(function (this: HTMLElement) {
                    $(this).text("");
                });
            }

            this.removeErrorMessage($parent[0]);
        }
        else {
            input.setCustomValidity(failedInputValidation || "");
            $(input).addClass("js-validation-failed");
            $(input).removeClass("js-validation-success");
            if ($parent.hasClass("input-wrapper")) {
                $(input).parent().addClass("input-wrapper--failed");
                $(input).parent().removeClass("input-wrapper--success");
            }

            let errorMessage: string = "";
            if (typeof $input.data("errorlength") !== "undefined") {
                errorMessage = $input.data("errorlength");
            }
            else if (typeof $input.data("errorempty") !== "undefined") {
                errorMessage = $input.data("errorempty");
            }

            if (input.validity.tooShort || this.checkIfHasNumbers($(input).val() as string))
                this.addErrorMessage($parent[0], $input.data("errorlength"));
            else if ($input.val().length === 0)
                this.addErrorMessage($parent[0], $input.data("errorempty"));
            else
                this.addErrorMessage($parent[0], $input.data("errorinvalid"));

            if (errorMessage !== "") {
                // TODO: Ensure 'validationerrormessage' is used on 'payment.achteraf.html'.
                $input.siblings(".validationerrormessage").each(function (this: HTMLElement) {
                    $(this).text(errorMessage);
                });
            }
        }
    }

    private checkIfHasNumbers = (value: string): boolean => {
        return /\d/.test(value);
    }

    public customFieldValidation = (sender: any, event: Event | undefined): boolean | void => {
        event = event || (window.event as Event);

        const errors: string[] = [];

        this.customFieldValidationSuccess = true;

        let failedInput: HTMLInputElement | null = null;
        let failedInputValidation: string | null = null;

        const instance = this;

        // Only ever validate visible fields, so user cannot be forced to fill in fields they cannot see (which shouldn't happen anyway).
        $(".js-validation:visible").each(function (this: HTMLElement) {
            let input = $(this)[0] as HTMLInputElement;
            let $parent = $(input).parent();

            input.setCustomValidity("");

            if (input.getAttribute("type") === "tel") return;

            if (input.validity.valueMissing ||
                // Check if input only contains spaces.
                ($(input).val() as string).match(/^ *$/)) {
                if (failedInput == null) {
                    failedInput = input;
                    failedInputValidation = instance.fieldMandatory;
                }

                const fieldEmptyValue = $(input).data("errorempty") as string | undefined;
                if ($parent.hasClass("input-wrapper"))
                    $(input).parent().attr("data-errorempty", $(input).data("errorempty"));

                if (fieldEmptyValue && !errors.includes(fieldEmptyValue))
                    errors.push(fieldEmptyValue);

                $(input).addClass("js-validation-failed");
                $(input).removeClass("js-validation-success");
                if ($parent.hasClass("input-wrapper")) {
                    $(input).parent().addClass("input-wrapper--failed");
                    $(input).parent().removeClass("input-wrapper--success");
                }

                return;
            }
            else {
                $(input).removeClass("js-validation-failed");
                $(input).addClass("js-validation-success");
                if ($parent.hasClass("input-wrapper")) {
                    $(input).parent().removeClass("input-wrapper--failed");
                    $(input).parent().addClass("input-wrapper--success");
                }
                $(input).removeClass("field_error");
            }

            switch ($(input).attr("type")) {
                case "email":
                    {
                        if (input.validity.typeMismatch ||
                            input.validity.patternMismatch) {
                            if (failedInput == null) {
                                failedInput = input;
                                failedInputValidation = instance.EmailValidationError;
                            }

                            const fieldInvalidValue = $(input).data("errorinvalid") as string | undefined;
                            instance.addErrorMessage($parent[0], $(input).data("errorinvalid"));

                            if (fieldInvalidValue && !errors.includes(fieldInvalidValue))
                                errors.push(fieldInvalidValue);

                            $(input).addClass("js-validation-failed");
                            $(input).removeClass("js-validation-success");
                            if ($parent.hasClass("input-wrapper")) {
                                $(input).parent().addClass("input-wrapper--failed");
                                $(input).parent().removeClass("input-wrapper--success");
                            }
                        }
                        else {
                            $(input).removeClass("js-validation-failed");
                            $(input).addClass("js-validation-success");
                            if ($parent.hasClass("input-wrapper")) {
                                $(input).parent().removeClass("input-wrapper--failed");
                                $(input).parent().addClass("input-wrapper--success");
                            }
                            $(input).removeClass("field_error");

                            instance.removeErrorMessage($parent[0]);
                        }

                        break;
                    }
                case "tel":
                    {
                        if (input.validity.typeMismatch) {
                            if (failedInput == null) {
                                failedInput = input;
                                failedInputValidation = instance.phoneValidationError;
                            }

                            const fieldInvalidValue = $(input).data("errorinvalid") as string | undefined;
                            instance.addErrorMessage($parent[0], $(input).data("errorinvalid"));

                            if (fieldInvalidValue && !errors.includes(fieldInvalidValue))
                                errors.push(fieldInvalidValue);

                            $(input).addClass("js-validation-failed");
                            $(input).removeClass("js-validation-success");
                            if ($parent.hasClass("input-wrapper")) {
                                $(input).parent().addClass("input-wrapper--failed");
                                $(input).parent().removeClass("input-wrapper--success");
                            }
                        }
                        else {
                            $(input).removeClass("js-validation-failed");
                            $(input).addClass("js-validation-success");
                            if ($parent.hasClass("input-wrapper")) {
                                $(input).parent().removeClass("input-wrapper--failed");
                                $(input).parent().addClass("input-wrapper--success");
                            }
                            $(input).removeClass("field_error");

                            instance.removeErrorMessage($parent[0])
                        }

                        break;
                    }
            }

            switch ($(input).attr("name")) {
                case "first":
                case "first-delivery":
                    {
                        if (input.validity.tooShort || instance.checkIfHasNumbers($(input).val() as string)) {
                            const errorLengthMessage = $(input).data("errorlength");

                            if (failedInput == null) {
                                failedInput = input;
                                failedInputValidation = errorLengthMessage;
                            }

                            if (errorLengthMessage && !errors.includes(errorLengthMessage)) {
                                errors.push(errorLengthMessage);
                                instance.addErrorMessage($parent[0], errorLengthMessage);
                            }

                            $(input).addClass("js-validation-failed");
                            $(input).removeClass("js-validation-success");
                            if ($parent.hasClass("input-wrapper")) {
                                $(input).parent().addClass("input-wrapper--failed");
                                $(input).parent().removeClass("input-wrapper--success");
                            }
                        }
                        else {
                            $(input).removeClass("js-validation-failed");
                            $(input).addClass("js-validation-success");
                            if ($parent.hasClass("input-wrapper")) {
                                $(input).parent().removeClass("input-wrapper--failed");
                                $(input).parent().addClass("input-wrapper--success");
                            }
                            $(input).removeClass("field_error");

                            instance.removeErrorMessage($parent[0]);
                        }
                    }
            }

            // Check if field meets the minimum length requirement
            if ($(input).attr('minlength') !== undefined) {
                const minimumLength = parseInt($(input).attr("minlength"));

                if (minimumLength !== undefined && ($(input).val() as string).trim().length >= minimumLength) {

                    $(input).removeClass("js-validation-failed");
                    $(input).addClass("js-validation-success");
                    if ($parent.hasClass("input-wrapper")) {
                        $(input).parent().removeClass("input-wrapper--failed");
                        $(input).parent().addClass("input-wrapper--success");
                    }

                    instance.removeErrorMessage($parent[0]);
                }
            }
        });

        $("#errors").empty();

        // Push errors to dataLayer.
        console.log(`errors: ${errors.length}`);

        $((errors as any)).each(function (this: string) {
            if (this != null && this != "" && !this.toString().startsWith('-')) {
                sendDataLayer({
                    'event': 'Error',
                    'category': 'Error',
                    'action': document.location.pathname,
                    'label': this.toString()
                });

                $("#errors").append(this.toString() + "<br />");
            }
        });

        if (failedInput && failedInputValidation) {
            // Extra check to prevent required element not being visible (like orderprocess step 2 street).
            const hiddenParent = $(failedInput).parents(":not(:visible).hidden");
            if (hiddenParent.length > 0)
                $(hiddenParent).removeClass("hidden");

            failedInput.setCustomValidity(failedInputValidation);

            $("html, body").animate({ scrollTop: 0 }, 500);

            this.customFieldValidationSuccess = false;

            event.stopPropagation();
            event.preventDefault();

            return false;
        }
    }

    private addErrorMessage = (parent: HTMLElement, errorMessage: string) => {

        const $parent = $(parent);
        const errorDiv = document.createElement("div");

        if (!errorMessage) return;

        if ($parent.parent().find(".input-wrapper-error").length > 0) {
            $parent.parent().find(".input-wrapper-error").text(errorMessage);
            return;
        }

        errorDiv.classList.add("input-wrapper-error");
        $(errorDiv).text(errorMessage);

        $parent.after($(errorDiv));
    }

    private removeErrorMessage = (parent: HTMLElement) => {
        const $parent = $(parent);

        if ($parent.parent().find(".input-wrapper-error").length > 0) {
            $parent.parent().find(".input-wrapper-error").remove();
        }
    }
}

export function validateCustomField(input: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement, removeValidation?: boolean): void
{
    if (typeof removeValidation === "undefined" || removeValidation === null)
        removeValidation = false;

    let fieldMandatory: string;
    let EmailValidationError: string;
    let phoneValidationError: string;
    let nameTooShort: string;
    let valid: boolean = true;
    let failedInputValidation: string | null = null;
    const $input = $(input);

    // When removing validation, skip validating and treat the field as valid.
    if (!removeValidation)
    {
        if (input.validity.typeMismatch || ($input.val() as string).match(/^ *$/))
        {
            valid = false;
            failedInputValidation = fieldMandatory;
        }
        else
        {
            switch ($input.attr("type"))
            {
                case "email":
                    {
                        if (input.validity.typeMismatch || input.validity.patternMismatch)
                        {
                            valid = false;
                            failedInputValidation = EmailValidationError;
                        }

                        break;
                    }
                case "tel":
                    {
                        if (input.validity.typeMismatch)
                        {
                            valid = false;
                            failedInputValidation = phoneValidationError;
                        }

                        break;
                    }
                case "radio":
                    {
                        // Check if any radio button with same name was checked.
                        if (typeof input.type !== "undefined" && input.type !== null && input.type === "radio" &&
                            typeof input.name !== "undefined" && input.name !== null && input.name.length > 0)
                        {
                            if ($(`input[type="${input.type}"][name="${input.name}"]:checked`).length <= 0)
                            {
                                valid = false;
                                failedInputValidation = fieldMandatory;
                            }
                        }
                    }
            }

            switch ($input.attr("name"))
            {
                case "first":
                case "first-delivery":
                    {
                        const firstValue = $input.val() as string;

                        if (firstValue && firstValue.length === 1)
                        {
                            valid = false;
                            failedInputValidation = nameTooShort;
                        }
                    }
            }

            // Check if field meets the minimum length requirement
            if (typeof $input.data("errorminlength") !== "undefined")
            {
                let minimumLength = $input.data("errorminlength");

                if (typeof minimumLength !== "undefined" && ($input.val() as string).trim().length < minimumLength)
                {
                    valid = false;
                    failedInputValidation = fieldMandatory;
                }
            }
        }
    }

    // Also run when removing validation, to do the removing itself.
    if (valid || removeValidation)
    {
        input.setCustomValidity("");
        $input.removeClass("js-validation-failed field_error");

        // For radio buttons and checkboxes, remove invalid class from all with same name.
        if ((input.type === "radio" || input.type === "checkbox") &&
            input.name.length > 0)
        {
            // Inputs of same type and name that have validation failed class.
            const selector = `input[type="${input.type}"][name="${input.name}"].js-validation-failed`;

            $(selector).removeClass("js-validation-failed field_error");
        }

        if ($input.hasClass("js-validation-showmessage") && $input.siblings(".validationerrormessage").length > 0)
        {
            $input.siblings(".validationerrormessage").each(function (this: HTMLElement)
            {
                $(this).text("");
            });
        }
    }
    else
    {
        input.setCustomValidity(failedInputValidation || "");
        $input.addClass("js-validation-failed");

        if ($input.hasClass("js-validation-showmessage") && $input.siblings(".validationerrormessage").length > 0)
        {
            let errorMessage: string = "";
            if (typeof $input.data("errorlength") !== "undefined")
                errorMessage = $input.data("errorlength");
            else if (typeof $input.data("errorempty") !== "undefined")
                errorMessage = $input.data("errorempty");

            if (errorMessage !== "")
            {
                // TODO: Ensure 'validationerrormessage' is used on 'payment.achteraf.html'.
                $input.siblings(".validationerrormessage").each(function (this: HTMLElement)
                {
                    $(this).text(errorMessage);
                });
            }
        }
    }
}